import { ErrorTypeEnum } from '@sola/schema/dotcom/shared/errors.ts';

import { UserError } from '../errors-user.ts';

export const userErrorBadParam = (badParam: string) =>
  new UserError({
    type: ErrorTypeEnum.BadParameter,
    data: {
      badParam,
    },
    statusCode: 400,
  });

export const userErrorBadParams = (badParam: string[]) =>
  new UserError({
    type: ErrorTypeEnum.BadParameter,
    data: {
      badParam,
    },
    statusCode: 400,
  });
